/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

// storageUtils.js
export function setRilletUserId(value) {
    sessionStorage.setItem('rilletUserId', value);
    window.dispatchEvent(new Event('RilletUserIdChange'));
  }
  
  export function clearRilletUserId() {
      sessionStorage.removeItem('rilletUserId');
      window.dispatchEvent(new Event('RilletUserIdChange'));
  }
